// A small, curated categorical palette used by insight tiles that colour
// arbitrary labels (expense tags, teams, users). The palette harmonises
// with the app's primary purple and stays legible on both light and dark
// text backgrounds. Adding an entry is safe; removing or reordering shifts
// which label a repeat viewer sees against which colour, so treat this
// list as append-only.
export const INSIGHT_PALETTE = [
  '#6418C3', // primary purple
  '#17A2B8', // teal
  '#F0A040', // amber
  '#E14D8B', // rose
  '#10B981', // emerald
  '#3B82F6', // blue
  '#F87171', // coral
  '#84CC16', // olive
];

/**
 * Deterministic colour picker for a label. Same label always resolves to the
 * same palette entry across renders and sessions, so a viewer's mental model
 * of "Fuel is amber" does not shift on refresh. A simple accumulating hash on
 * the label's UTF-16 code units, modulo the palette length. Good enough for
 * distinguishing a couple of dozen categories on one screen.
 */
export const colorForLabel = (label) => {
  const source = String(label ?? '');
  let hash = 0;
  for (let index = 0; index < source.length; index += 1) {
    hash = (hash * 31 + source.charCodeAt(index)) >>> 0;
  }
  return INSIGHT_PALETTE[hash % INSIGHT_PALETTE.length];
};

export const colorsForLabels = (labels) => (labels ?? []).map(colorForLabel);
